// extracted by mini-css-extract-plugin
export default {"resetPassword":"reset-password_resetPassword__0qElq","container":"reset-password_container__SSnT8","form":"reset-password_form__vN88k","rotate":"reset-password_rotate__RSAgg"};